import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { ForfeitureSummary } from "../layouts";

import { ROUTES, ApplicationRoute, MANAGE_FORFEITURE_ROUTES } from "../utils";

export const ManageForfeitureRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        path={[
          `${MANAGE_FORFEITURE_ROUTES.FORFEITURE_SUMMARY}`,
          `${MANAGE_FORFEITURE_ROUTES.FORFEITURE_SUMMARY}`,
        ]}
        component={ForfeitureSummary}
      />
      <Redirect
        exact
        from={ROUTES.FORFEITURE}
        to={MANAGE_FORFEITURE_ROUTES.FORFEITURE_SUMMARY}
      />
    </Switch>
  );
};
